import { render } from "./BrandMedOverNet.vue?vue&type=template&id=dcecb80a"
import script from "./BrandMedOverNet.vue?vue&type=script&lang=ts"
export * from "./BrandMedOverNet.vue?vue&type=script&lang=ts"

import "./BrandMedOverNet.vue?vue&type=style&index=0&id=dcecb80a&lang=scss"
script.render = render

export default script